import axios from "axios";
const jsonConfig = require("../../Config.json");

const getPlacementTemplates = async (isActive = true) => {
  try {
    const response = await axios.get(
    jsonConfig.apiUrl + "placementTemplate/",
      {
        params: { isActive },
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default getPlacementTemplates;
